import { useMemo } from "react";

import { type GetOrganizationsQuery } from "../../shared/api/queries";
import { type KeyedOption } from "../../shared/models";
import { type GetAllPreSubmissionInfoWithOrgResourcesQuery } from "../api/queries";

import { makeLensSpaceOptions } from "./makeLensSpaceOptions";

export const useLensSpaceOptions = (
    data: GetOrganizationsQuery | GetAllPreSubmissionInfoWithOrgResourcesQuery | undefined,
    selectedOrgId: string,
): KeyedOption[] => {
    return useMemo(() => {
        if (!data || !selectedOrgId) return [];
        const selectedOrganization = data.getMyLensesOrganizations.organizationsList.find(
            (org) => org.id === selectedOrgId,
        );
        if (!selectedOrganization) return [];

        return makeLensSpaceOptions(selectedOrganization.lensSpacesList);
    }, [data, selectedOrgId]);
};
